<table class="table table-sm">
  <thead>
    <th>Rule</th>
    <th>Status</th>
    <th>Created</th>
  </thead>
  <tbody>
    @for (subscription of subscriptions; track subscription; let i = $index) {
      <tr>
        <td>{{subscription.rulePackageTitle}}</td>
        <td>{{subscription.contactInviteStatus}}</td>
        <td>{{subscription.contactCreatedAt | amTimeAgo}}</td>
      </tr>
    }
  </tbody>
</table>
